import React, { useEffect, useState } from 'react'
import {  AccordionDetails } from '@mui/material';
import styled from 'styled-components';
import { Form,Button, ButtonsContainer, InputContainer, AmountButton, ErrorSpan, } from './DepositElements'
import formasDePago from '../../assets/images/formasDePago.png';
import { formatNumber, toLocale, toLocaleString } from '../../utils/tools';
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { selectCurrency } from "../../features/user/userSlice";
import { selectLimites } from '../../features/limitaciones/limitacionesSlice';


const FormPagoEfectivo = ({form,
  handleChange,
  handleClose,
  handleSubmit,
  loading,}) => {
  const moneda = useSelector(selectCurrency);
  const [monto, setMonto] = useState(0);
  const [t] = useTranslation('global');
  const [blur, setBlur] = useState(false);

  const limitaciones = useSelector(selectLimites);
  const [montoMinimo, setMontoMinimo] = useState(50)
  const [montoMaximo, setMontoMaximo] = useState(2500)

  useEffect(()=>{
    if(limitaciones.minimo_deposito>0 && limitaciones.minimo_deposito>50) setMontoMinimo(limitaciones.minimo_deposito)

    if(limitaciones.maximo_deposito>0 && limitaciones.maximo_deposito < 2500) setMontoMaximo(limitaciones.maximo_deposito)
  },[limitaciones])

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  

const changeAmount = (valor) => {
    handleMonto({target: {value: valor, name: 'monto1'}});
  }
  return (
    <ContainerContent>
      <Form className='pagoEfectivo'>
      <h3 style={{fontSize: "15px", color: 'black'}}>Monto:</h3>
        <AmountButton>
          <Button onClick={()=>{changeAmount('100,00')}}>S/100</Button>
          <Button onClick={()=>{changeAmount('150,00')}}>S/150</Button>
          <Button onClick={()=>{changeAmount('200,00')}}>S/200</Button>
          <Button onClick={()=>{changeAmount('500,00')}}>S/500</Button>
        </AmountButton>
        <div style={{fontSize: "15px", color: 'black'}}>- Mínimo: {toLocale(montoMinimo)} Sol</div>
        <div style={{fontSize: "15px", color:'black'}}>- Máximo: {toLocale(montoMaximo)} Sol</div>
        <InputContainer>
          <input type='text' 
          placeholder='0,00'
          name="monto1"
          value={form.monto1}
          maxLength={20} 
          onChange={(e)=>handleMonto(e)}/>
          {monto < montoMinimo && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {toLocaleString(montoMinimo)} {moneda}{" "}
          </ErrorSpan>
          )}

        {monto > montoMaximo && 
          <ErrorSpan>{t("deposit.amount-less-than")} {toLocaleString(montoMaximo)} {moneda} </ErrorSpan>
        }
        </InputContainer>
        <h4 style={{color:'black'}}>Genera un código de 9 dígitos y págalo a través de:</h4>
        <div className='bancos' style={{color:'black'}}>- Paga en Yape, Plin, BBVA, BCP, Interbank, Scotiabank, BanBif, Caja Arequipa y Banco Pichincha a través de la banca móvil, QR o en agentes y bodegas de Red Digital, Kasnet, Agente Niubiz, Tambo+, Western Union y Disashop.</div>
        <img src={formasDePago} alt='Formas de Pago' className='formasDePago'/>
        <ButtonsContainer>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-back")}
        </Button>
        <Button primary={true} disabled={((monto < montoMinimo || monto > montoMaximo) || loading)} onClick={handleSubmit}>
          {loading ? 'PROCESANDO...' : 'SIGUIENTE'}
        </Button>
      </ButtonsContainer>
      </Form>
    </ContainerContent>
  )
}

export default FormPagoEfectivo

const ContainerContent = styled(AccordionDetails)`
  background: transparent;
  color: #fff;
  padding: 0 !important;

  > div.pagoEfectivo {
    padding: 1rem !important;
    h3, h4 {
      margin: 0.5rem 0;
    }
    div {
      padding: 0.15rem;
      font-size: 1.3rem;
      color: #ccc;
    }
    .bancos {
      font-size: 0.8rem;
    }
    img {
      width: 100%;
      margin: 0.5rem 0;
    }
    div.button {
      text-align: center;
    }
  }
`;